module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAApCAYAAADNjfKJAAABVUlEQVRYR+2YsS5EQRSGvz8SDyAbRLyAKERoRESp8Awqiq0kotmNUiURCY+gp0IUCoWIWkQlCgqRjUg0yiNHhmxusNe9e6fZmfLknvPN/HPmzLkjADObA7aAKaDfbRWNV+AQaEpqycwWgGOgryLgT2HvgEmHXwCzEcFfqLrDn4HBYDkATgpOZAJYbfNdA94ysTaBkWDbdngLqAVDQ5Lv/b+HmS0CR22Ow5J8Yd/DzG6A8WDYSfAke0q4dNRyK5CKTCqvQNSLxZuS0zbZa5JeYt1qA8AtMARcSZrJHpXKrtTQC/oF5U3FpaT3qPBORaHSlSf4bwok2bvevXZKtnAUq2mdE/wvBXo628+B+aDORtf+1XIm3DSwBzwBK1Hh2Qn2NvwRGA2S3AMPefav5DfXQMNl3weWSgYr4r7ucH8jOQPGikQo4VNXKPj+9rYc4R3uEwe47LsfqCqxpag3MhgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 3